
<div
    class="activity-indicator"
    :data-active="isActive"
/>
